import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

// Tips:
// 如果H5在APP中，且使用`H5 FaceID API`，APP需要完成相应的兼容性配置，参考: https://faceid.com/document/faceid-guide-docs/APP_import_h5

/**
 * 人脸识别V5请求参数
 * @bizToken 通过后台接口获取, 参考 https://faceid.com/document/faceid-guide-docs/app_api_product_analyze
 */
export type FaceIDV5Options = {
  bizToken: string;
};

/**
 * 人脸识别V5返回结果
 * @message 预留消息
 */
export type FaceIDV5Response = {
  message: string;
};

export type FabricMarkShowFaceIdV5Api = (
  options: FaceIDV5Options
) => Promise<FaceIDV5Response>;

/**
 * 人脸识别SDK V5
 * 逻辑: H5通过服务端获取bizToken => H5调用showFaceIdV5 => APP调用人脸识别SDK V5 => H5通过服务端获取结果
 * 参考: https://faceid.com/document/faceid-guide-docs/app_access_guidence
 */
export const showFaceIdV5: FabricMarkShowFaceIdV5Api = (
  options: FaceIDV5Options
): Promise<FaceIDV5Response> => {
  return new Promise<FaceIDV5Response>((resolve, reject) => {
    core.call<
      'fabric_mark_faceid.showFaceIdV5',
      FaceIDV5Options,
      FaceIDV5Response
    >('fabric_mark_faceid.showFaceIdV5', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
